import Notifications from "components/notifications/Notifications";

export default function NotificationsTab() {
  return (
    <div>
     <Notifications/>
    </div>
  );
} 